














































import { Component, Vue } from "vue-property-decorator";
import { authService } from "../api/authentication/authentication.api";
import { authenticationStore } from "../api/authentication/authentication.module";
import { IOTPOptions } from "../interfaces/IOTPOptions";

@Component
export default class OTPScreen extends Vue {
  payload: IOTPOptions = {
    identifiers: [],
    routeName: ""
  };

  countdown = 0;

  intervalHandler: any = null;

  get canResend() {
    return this.countdown === 0;
  }

  async mounted() {
    try {
      this.payload = this.getOTPScreenPayload(this.$route.params.hash);
    } catch (error) {
      this.$router.back();
    } finally {
      if (this.payload.init) {
        await this.sendOtp();
      } else {
        this.countdownHandler();
      }
    }
  }

  countdownHandler() {
    this.countdown = 60;
    this.intervalHandler = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.intervalHandler);
      }
    }, 1000);
  }

  handleOnComplete(value: string) {
    this.payload.code = value;
    this.handle();
  }

  async sendOtp() {
    if (!this.canResend) return;
    try {
      this.isLoading = true;
      await this.requestWrapper(
        authService.sendOTP({
          identifiers: this.payload.identifiers,
          useEmail: this.payload.useEmail
        })
      );
    } finally {
      this.isLoading = false;
    }

    this.countdownHandler();
  }

  async handle() {
    try {
      const requestParams = { identifiers: this.payload.identifiers, code: this.payload.code };
      this.isLoading = true;
      const response = await this.requestWrapper(
        this.payload.verifyAccount
          ? authService.verifyAccount({
              code: requestParams.code as string,
              identifiers: requestParams.identifiers
            })
          : authService.verifyOTP({
              code: requestParams.code as string,
              identifier: requestParams.identifiers[0],
              shadow: this.payload.shadow
            })
      );
      if (response.data?.user) {
        authenticationStore.SET_USER(response.data);
      }

      let params = this.payload.routeParams;

      if (this.payload.isHashed) {
        params = {
          hash: this.makeOTPScreenPayload({
            ...this.payload
          })
        };
      }

      if (this.payload.verifyAccount) {
        this.toastSuccess("Account verified, please login to continue");
      }

      this.$router.push({ name: this.payload.routeName, params: params });
    } catch (error) {
    } finally {
      this.isLoading = false;
    }
  }
}
